import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth/auth.guard';
import { hasUnsavedChangesGuard } from './auth/has-unsaved-changes.guard';
import { LoginComponent } from './auth/login/login.component';
import { WritePermissionGuard } from './auth/write-permission.guard';
import { BlockingComponent } from './blocking/blocking.component';
import { CustomerTypesComponent } from './customer-tags/customer-tags.component';
import { DietaryTagsComponent } from './dietary-tags/dietary-tags.component';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { ReportsComponent } from './reports/reports.component';
import { ReservationListComponent } from './reservation-list/reservation-list.component';
import { ReservationSearchComponent } from './reservation-search/reservation-search.component';
import { ReservationTagsComponent } from './reservation-tags/reservation-tags.component';
import { ReservationComponent } from './reservation/reservation.component';
import { SettingsFormComponent } from './settings-form/settings-form.component';
import { SourceComponent } from './source/source.component';
import { TablesPlanComponent } from './tables-plan/tables-plan.component';

const routes: Routes = [
  { path: 'auth/login', component: LoginComponent },
  { path: 'auth/auto/:user/:pass', component: LoginComponent },
  { path: 'reservations/add', component: ReservationComponent, canActivate: [AuthGuardService, WritePermissionGuard], data: { isNew: true, walkIn: false, writePermission: 'AddReservation' } },
  { path: 'reservations/copy/:id', component: ReservationComponent, canActivate: [AuthGuardService, WritePermissionGuard], data: { isNew: true, walkIn: false, isCopy: true, writePermission: 'AddReservation' } },
  { path: 'reservations/edit/:id', component: ReservationComponent, canActivate: [AuthGuardService, WritePermissionGuard], data: { isNew: false, writePermission: ['View', 'EditReservation'] } },
  { path: 'reservations/search', component: ReservationSearchComponent, canActivate: [AuthGuardService, WritePermissionGuard], data: { writePermission: 'SearchReservation' } },
  { path: 'walkin/add', component: ReservationComponent, canActivate: [AuthGuardService, WritePermissionGuard], data: { isNew: true, walkIn: true, writePermission: 'AddWalkIn' } },
  { path: 'dietary-tags', component: DietaryTagsComponent, canActivate: [AuthGuardService] },
  { path: 'reservation-tags', component: ReservationTagsComponent, canActivate: [AuthGuardService] },
  { path: 'customer-tags', component: CustomerTypesComponent, canActivate: [AuthGuardService] },
  { path: 'users', component: EmployeeListComponent, canActivate: [AuthGuardService] },
  { path: 'sources', component: SourceComponent, canActivate: [AuthGuardService] },
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuardService, WritePermissionGuard], data: { writePermission: 'visits_report_overview' } },
  { path: 'blocking', component: BlockingComponent, canActivate: [AuthGuardService, WritePermissionGuard], data: { writePermission: 'CheckBlocking' } },
  { path: 'tables-plan', component: TablesPlanComponent, canActivate: [AuthGuardService], canDeactivate: [hasUnsavedChangesGuard] },
  { path: 'settings', component: SettingsFormComponent, canActivate: [AuthGuardService] },
  { path: '**', pathMatch: 'full', component: ReservationListComponent, canActivate: [AuthGuardService] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
